import React from 'react';
import { Container } from '@amzn/awsui-components-react';
import { WidgetDataType } from '../interfaces';
import styles from './styles.module.scss';

export function BaseStaticWidget({ config }: { config: WidgetDataType }) {
  const Wrapper = config.provider !== null && config.provider !== void 0 ? config.provider : React.Fragment;
  return (
    <div className={styles.staticWidget} style={{ minHeight: config.staticMinHeight }}>
      <Wrapper>
        <Container
          header={<config.header />}
          fitHeight={true}
          footer={config.footer && <config.footer />}
          disableContentPaddings={config.disableContentPaddings}
          className="widget-container"
        >
          <config.content />
        </Container>
      </Wrapper>
    </div>
  );
}
